import Keycloak from "keycloak-js";

let keycloakInstance = null;

const resolveDefaultKeycloakUrl = () => {
  if (import.meta.env.VITE_KEYCLOAK_URL) {
    return import.meta.env.VITE_KEYCLOAK_URL;
  }
  if (typeof window !== "undefined") {
    return `${window.location.protocol}//${window.location.hostname}:8080`;
  }
  return "http://localhost:8080";
};

export const getKeycloak = () => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak({
      url: resolveDefaultKeycloakUrl(),
      realm: import.meta.env.VITE_KEYCLOAK_REALM || "bank-support",
      clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "portail-support",
    });
  }
  return keycloakInstance;
};


// Force localhost to avoid cookie domain mismatch with 127.0.0.1
const getRedirectUri = () => {
  if (typeof window !== "undefined" && window.location.hostname === "127.0.0.1") {
    return `http://localhost:${window.location.port}${window.location.pathname}`;
  }
  return undefined; // Let keycloak-js use default
};

export const keycloakInitOptions = {
  onLoad: "login-required",
  pkceMethod: "S256",
  checkLoginIframe: false,
  responseMode: "query", 
  useNonce: false,
  redirectUri: getRedirectUri(),
};
